/* LE BÂNQUET — flechas del carrusel de videos
   La fila de videos se arrastra sola en táctil y con trackpad, pero con
   ratón el desplazamiento horizontal obliga a mantener Mayús. Estas
   flechas resuelven eso; si todo cabe en pantalla, no aparecen. */
(() => {
  if (window.__lbCarrusel) return;
  window.__lbCarrusel = true;

  const filas = document.querySelectorAll('.lb-videos');
  if (!filas.length) return;

  const flecha = (sentido) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `lb-flecha lb-flecha--${sentido === -1 ? 'izq' : 'der'}`;
    b.setAttribute('aria-label', sentido === -1 ? 'Ver los anteriores' : 'Ver los siguientes');
    b.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 16 16" aria-hidden="true" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      (sentido === -1 ? '<path d="M10 3.5 5.5 8 10 12.5"/>' : '<path d="M6 3.5 10.5 8 6 12.5"/>') +
      '</svg>';
    return b;
  };

  filas.forEach((fila) => {
    const marco = document.createElement('div');
    marco.className = 'lb-carrusel';
    fila.parentNode.insertBefore(marco, fila);
    marco.appendChild(fila);

    const izq = flecha(-1);
    const der = flecha(1);
    marco.append(izq, der);

    const paso = () => {
      const pieza = fila.querySelector('.lb-video');
      if (!pieza) return fila.clientWidth;
      const ancho = pieza.getBoundingClientRect().width;
      const hueco = parseFloat(getComputedStyle(fila).columnGap) || 0;
      // Avanza tantas piezas como quepan enteras, mínimo una.
      const caben = Math.max(1, Math.floor(fila.clientWidth / (ancho + hueco)));
      return caben * (ancho + hueco);
    };

    /* En el teléfono el carrusel da la vuelta, así que no hay extremos que
       marcar. Se declara aquí arriba porque pintar() ya lo consulta. */
    const enFila = window.matchMedia('(max-width: 749px)');

    const pintar = () => {
      const sobra = fila.scrollWidth - fila.clientWidth;
      marco.classList.toggle('lb-carrusel--fijo', sobra <= 2);
      if (enFila.matches) {
        izq.disabled = false;
        der.disabled = false;
        return;
      }
      izq.disabled = fila.scrollLeft <= 2;
      der.disabled = fila.scrollLeft >= sobra - 2;
    };

    izq.addEventListener('click', () => fila.scrollBy({ left: -paso(), behavior: 'smooth' }));
    der.addEventListener('click', () => fila.scrollBy({ left: paso(), behavior: 'smooth' }));
    fila.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();

    /* --- Vuelta infinita en el teléfono ---------------------------------
       No se clonan las piezas: se mueve el mismo nodo de un extremo al
       otro y se compensa el desplazamiento en el mismo fotograma. Clonar
       dejaría los videos duplicados sin sus controles, porque lb-video.js
       ya enganchó los originales al cargar la página.

       El movimiento se hace cuando el dedo ya soltó y el carrusel se
       detuvo: tocar el desplazamiento en mitad del gesto no funciona en
       iOS y se ve como un tirón. */
    let reposo = null;

    const mover = (alFinal) => {
      const pieza = alFinal ? fila.firstElementChild : fila.lastElementChild;
      if (!pieza) return 0;
      const hueco = parseFloat(getComputedStyle(fila).columnGap) || 0;
      const ancho = pieza.getBoundingClientRect().width + hueco;

      const comportamiento = fila.style.scrollBehavior;
      const anclaje = fila.style.scrollSnapType;
      fila.style.scrollBehavior = 'auto';
      fila.style.scrollSnapType = 'none';

      if (alFinal) {
        fila.appendChild(pieza);
        fila.scrollLeft -= ancho;
      } else {
        fila.insertBefore(pieza, fila.firstElementChild);
        fila.scrollLeft += ancho;
      }

      // Se restaura en el siguiente fotograma, ya con la posición corregida.
      requestAnimationFrame(() => {
        fila.style.scrollBehavior = comportamiento;
        fila.style.scrollSnapType = anclaje;
      });
      return ancho;
    };

    /* Se mantiene siempre al menos una pieza a cada lado, así que nunca
       se llega a un borde y el carrusel no tiene principio ni final. */
    const equilibrar = () => {
      if (!enFila.matches) return;
      const pieza = fila.firstElementChild;
      if (!pieza || fila.children.length < 3) return;
      const hueco = parseFloat(getComputedStyle(fila).columnGap) || 0;
      const ancho = pieza.getBoundingClientRect().width + hueco;
      let vueltas = 0;
      while (fila.scrollLeft > ancho * 1.5 && vueltas < 20) { mover(true); vueltas += 1; }
      while (fila.scrollLeft < ancho * 0.5 && vueltas < 20) { mover(false); vueltas += 1; }
    };

    fila.addEventListener('scroll', () => {
      clearTimeout(reposo);
      reposo = setTimeout(equilibrar, 140);
    }, { passive: true });

    // Se empieza con una pieza ya colocada a la izquierda: sin ella, el
    // primer arrastre hacia atrás chocaría contra el borde.
    if (enFila.matches && fila.children.length > 2) {
      requestAnimationFrame(() => { mover(false); });
    }
  });
})();
